import { Modal, ModalProvider } from '@joor/design-system'
import styled from 'styled-components/macro'

import usePortal from 'hooks/usePortal'

import { WarningContent } from './components/WarningContent'

export function UpdateAddressWarningModal({
  isBrand,
  isSubmitting,
  onContinue,
  onClose,
}: Props) {
  const Portal = usePortal()

  return (
    <Portal>
      <ModalProvider backgroundComponent={StyledBackgroundComponent}>
        <Modal
          title={{
            text: 'Updates local to this order',
            iconName: 'warning',
          }}
          isOpen
          onClose={onClose}
          size="medium"
        >
          <Modal.Content>
            <WarningContent isBrand={isBrand} />
          </Modal.Content>
          <Modal.Actions
            primaryButton={{
              text: 'Continue',
              handler: onContinue,
              loading: isSubmitting,
            }}
            secondaryButtonText="Cancel"
          />
        </Modal>
      </ModalProvider>
    </Portal>
  )
}

export type Props = {
  isBrand: boolean
  isSubmitting: boolean
  onContinue: () => void
  onClose: () => void
}

const StyledBackgroundComponent = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
  backdrop-filter: blur(3px);
  background-color: rgba(0, 0, 0, 0);
  align-items: center;
  justify-content: center;
`
